<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="viewWidth"
    :height="viewHeight"
    :viewBox="`0 0 ${viewWidth} ${viewHeight}`"
    :class="$style.icon"
  >
    <slot />
  </svg>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'IconSvgBase',
  props: {
    viewWidth: {
      type: Number,
      default: 0,
    },
    viewHeight: {
      type: Number,
      default: 0,
    },
  },
})
</script>

<style lang="scss" module>
.icon {
  fill: currentcolor;
}
</style>
